<template>
    <a
        href="javascript:history.back();"
        class="flex items-center mr-2 cursor-pointer"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-3 h-3 mr-2 text-green-400"
            fill="currentColor"
            viewBox="0 0 320 512"
        >
            <path
                d="M34.52 239.03l194.34-194.34c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.38 24.52.04 33.9L131.5 256l154.01 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            />
        </svg>

        {{ text }}
    </a>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                default: 'Back',
            },
        },
    };
</script>
